import { GlobalConfigType } from 'actions'
import { FieldOrigin, LoanFieldProps } from 'config'
import { store } from 'reducers'

import { IOtherIncomeRow } from '../BorrowerInformation/types'
import { BorrowerSeperator } from '../config'

export function employmentAndIncomeValidate(
  borrowerSeparator: BorrowerSeperator | string = BorrowerSeperator.BORROWER,
): boolean {
  const { globalConfigReducer, borrower } = store.getState()
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (((loanFieldProperties as any)['visibility'] || {})[FieldOrigin.EmploymentAndIncome] === false) {
    return true
  }
  const otherIncome = borrower[borrowerSeparator]?.otherIncome
  const rows = (Array.isArray(otherIncome?.rows) ? otherIncome.rows : []) as IOtherIncomeRow[]
  if (!rows.length) return true
  return rows.every((r) => Boolean(r.borrowerSeperator && r.incomeType))
}
